$.fn.keyboardTrap = function (options) {
    var $this = $(this);
    
    // Setting defaults
    settings = $.extend({
        'sustainToggleFocus': true,
        'activeClass': ''
    }, options);

    setTimeout(function() {
        var tabbable = $this.find(
            'a[href]:visible,' +
            'area[href]:visible,' +
            'input:not([disabled]):visible,' +
            'select:not([disabled]):visible,' +
            'textarea:not([disabled]):visible,' +
            'button:not([disabled]):visible,' +
            'iframe:visible,' +
            'object:visible,' +
            'embed:visible,' +
            '[tabindex="0"]:visible,' +
            '[contenteditable]:visible'
        );

        var firstTabbable = tabbable.first();
        var lastTabbable = tabbable.last();
        
        if ( settings.sustainToggleFocus === true ) {
            
            // Set focus on parent surround
            firstTabbable = $(document.activeElement);
        } else {
            
            // Set focus on first input
            firstTabbable.focus();
        }
        
        // Redirect last tab to first input
        lastTabbable.on('keydown', function(e) {
            if (e.which === 9 && !e.shiftKey) {
                e.preventDefault();
                firstTabbable.focus();
            }
        });

        // Redirect first shift+tab to last input
        firstTabbable.on('keydown', function(e) {
            if (e.which === 9 && e.shiftKey && lastTabbable.is(':visible')) {
                e.preventDefault();
                lastTabbable.focus();
            }
        });
    }, 100);
};